import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { SnackBarService } from '@app/services/snack-bar.service';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { GroupService } from '@services/group.service';
import { Breadcrumb } from '@app/models/view-models/breadcrumb';
@Component({
  selector: 'app-groups-index',
  templateUrl: './groups-index.component.html',
  styleUrls: ['./groups-index.component.scss']
})
export class GroupsIndexComponent extends BaseComponent implements OnInit {
  public dataSource: any;
  public node: Breadcrumb;
  public data: any;
  public displayedColumns = ['name', 'playing_staff', 'member_count', 'cms_app_group', 'is_associated_users_group', 'actions'];
  public dataLoaded = false;
  constructor(
    public groupService: GroupService,
    public router: Router,
    public state: State,
    public snackbarService: SnackBarService,
    public dialog: MatDialog
  ) {
    super();
    this.setObjects({
      modelService: groupService,
      router,
      state,
      snackbarService,
      dialog
    });

    this.setPageVars({
      listenForIndexUpdate: true
    });
    this.modelServiceGetAll().then(() => (this.dataLoaded = true));
  }

  public updatedStatus(): void {
    this.state.message({ ['GroupIndexUpdate']: true });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.node = {
      label: 'Groups',
      link: 'groups',
      title: 'Groups'
    };
    this.buildSettingsBreadcrumb(this.node);
  }
}
